import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { addDays, format } from "date-fns";
import { toast } from "react-toastify";
import Overlay from "../Overlay";
import useWorks from "../../hooks/useWorks";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";

//style
import "../../styles/allWorkExchangeModal.scss";

//image
import SuccessArtWork from "../../assets/workExchange/success-artwork.png";
import { ReactComponent as DownloadSvg } from "../../assets/workExchange/download.svg";
import { ReactComponent as CopySvg } from "../../assets/icons/copy.svg";
import { CartContext } from "../../contexts/CartContext";

const PaymentSuccess = ({ onClose }) => {
  const { getFileWork } = useWorks();
  const { getLang } = useContext(AppContext);
  const { journal, cardDetails } = useContext(CartContext);

  const TranslationSuccess = getLang(langComponent.chat);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  useEffect(() => {}, []);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success(TranslationWorkExchange("Copied transaction to clipboard"));
  };

  const dowloadFile = async () => {
    journal.details.map(async (detail) => {
      await getFileWork(detail.work).then(async (_file) => {
        for (const file of _file) {
          const res = await fetch(file.link);
          const blob = await res.blob();
          const href = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.download = file.name;
          a.href = href;
          a.click();
          a.href = "";
          await new Promise((resolve) => setTimeout(resolve, 400));
        }
      });
    });
  };

  const handleDownload = async () => {
    dowloadFile().then(() => {
      toast.success(TranslationWorkExchange("Download Complete!"));
    });
  };

  if (!journal) {
    return null;
  }

  const { _id, createdOn, grandTotal } = journal;

  return (
    <Overlay
      onClose={onClose}
      style={{
        alignItems: "center",
        pointerEvents: "none",
      }}
    >
      <div className="success-payment-container">
        <div className="success-payment-container-content">
          <div className="success-payment-container-content-image">
            <img src={SuccessArtWork} />
            <div className="success-payment-container-content-image__text">
              {TranslationWorkExchange("Success")}
            </div>
          </div>

          <div className="success-payment-container-content-detail">
            <div className="success-payment-container-content-detail__start">
              {TranslationWorkExchange("Transaction ID")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {_id} <CopySvg onClick={() => handleCopy(_id)} />
            </div>
            <div className="success-payment-container-content-detail__start">
              {TranslationWorkExchange("Date")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {format(addDays(new Date(createdOn), 0), "dd/MM/yyyy")}
            </div>
            {cardDetails?.cardNo && (
              <>
                <div className="success-payment-container-content-detail__start">
                  {TranslationWorkExchange("Type payment")}
                </div>
                <div className="success-payment-container-content-detail__end">
                  {TranslationSuccess("Credit card")}{" "}
                  {cardDetails.cardNo.substring(cardDetails.cardNo.length - 3)}
                </div>
              </>
            )}
            <div className="success-payment-container-content-detail__start">
              {TranslationSuccess("Price")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {TranslationWorkExchange("THB")} {grandTotal.toLocaleString()}
            </div>
          </div>
          <div className="success-payment-container-content-footer">
            <div
              className={`success-payment-container-content-footer__download`}
              onClick={handleDownload}
            >
              <DownloadSvg /> {TranslationWorkExchange("Download")}
            </div>
            <div
              className="success-payment-container-content-footer__btn"
              onClick={onClose}
            >
              {TranslationWorkExchange("Done")}
            </div>
          </div>
        </div>
      </div>
    </Overlay>
  );
};

PaymentSuccess.propTypes = {};

export default PaymentSuccess;
